import { Student } from '../student';
import { School } from '../school';

export const enum PaymentType {
    'CASH',
    'CHECK',
    'TRANSFER',
    'DEPOSIT',
    'CREDIT_CARD',
    'PAYPAL',
    'OTHER'
}

export class Payment {
    constructor(
        public id?: number,
        public type?: PaymentType,
        public paymentDate?: any,
        public document?: string,
        public comments?: string,
        public payer?: Student,
        public school?: School,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment/payment.model.ts